





























































import { Dialog } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import HomeIcons from "@/components/home/swiperIcons.vue";
import activeList from "@/components/home/activeList.vue";
import tabBar from "@/components/home/tabBar.vue";
import tabManagerBar from "@/components/home/manageBar.vue";
import estateWorkerBar from "@/components/home/manageBar.vue";
// import { format } from "path";
const wx: any = (window as any).wx;
const activityManagementModule = namespace("activityManagement");
@Component({
	components: {
		HomeIcons,
		activeList,
		tabBar,
		tabManagerBar,
		estateWorkerBar,
	},
})
export default class Home extends Vue {
	managerHomeShow: boolean = false;
	estateWorkerShow: boolean = false;
	finished: boolean = false;
	loading: boolean = false;
	all_menu: Array<any> = [];
	loc_menu: Array<any> = [];
	activityListPageLoading!: boolean;
	topIcon: any = {
		list: [],
		num: 8,
	};
	classIcon: any = {
		list: [],
		num: 4,
	};
	pages: any = {
		pageNum: 1,
		pageSize: 50,
		totalPage: 0,
	};
	activeList: any = [];
	homeRouter: any = [];
	tabActive: number = 0;
	listLoading: boolean = false;
	
	reportSalesFlag: boolean = false
	noticeContent: string = '';
	noticeShow: boolean = false;
	mounted() {
		console.log(`全局路由表：${(this as any).$global.routes}`);
		this.managerHomeShow =
			((this as any).$global.routes &&
				(this as any).$global.routes.indexOf("/manageHome") >= 0) ||
			(this as any).$global.routes.indexOf("/estateWorker") >= 0
				? true
				: false;
		(this as any).estateWorkerShow =
			(this as any).$global.routes &&
			(this as any).$global.routes.indexOf("/estateWorker") >= 0
				? true
				: false;
		this.getPath();
		this.getActivityList();
		this.getNotice();

		// 开通上报销售的账号，如果昨日未上报销售数据，登录商户通后弹窗提示
		let tenantType:any = localStorage.getItem('ma6_businessEntityTypeId'),
				homeReportSalesTime:any = localStorage.getItem('homeReportSalesTime');
		if(tenantType == 2 && (this as any).$global.routes.indexOf("/reportSales") >= 0){
			let nowTime:any = (this as any).$format(new Date(),"YYYY.MM.DD")
			console.log(nowTime)
			if(!homeReportSalesTime || nowTime > homeReportSalesTime){
				this.getcurrentDaySaleRecord()
			}
		}
	}
	getPath() {
		this.topIcon.list = [
			{
				path: "/couponVerification",
				imgUrl: require("../image/icon_1.png"),
				desc: "券码核销",
			},
			{
				path: "/faceCoupon",
				imgUrl: require("../image/icon_2.png"),
				desc: "面对面赠券",
			},
			{
				path: "/retreatCoupon",
				imgUrl: require("../image/icon_10.png"),
				desc: "扫码退券",
			},
			{
				path: "/coupon",
				imgUrl: require("../image/icon_3.png"),
				desc: "券管理",
				msg: "券管理(商户端)",
			},
			{
				path: "/activityManagement",
				imgUrl: require("../image/icon_4.png"),
				desc: "活动管理",
			},
			{
				path: "/couponCancel",
				imgUrl: require("../image/icon_5.png"),
				desc: "核销记录",
			},
			{
				path: "/coupon/audit",
				imgUrl: require("../image/icon_1.png"),
				desc: "券管理",
				msg: "券管理(商管端)",
			},
			{
				path: "/linkedOrder",
				imgUrl: require("../image/icon_1.png"),
				desc: "关联订单",
				msg: "券管理(商管端)",
			},
			{
				path: "/faceIntegral",
				imgUrl: require("../image/icon_13.png"),
				desc: "面对面积分",
			},
			{
				path: "/activitySign",
				imgUrl: require("../image/icon_signup.png"),
				desc: "活动登记",
			},
			{
				path: "/writeoffCard",
				imgUrl: require("../image/icon_giftcard_cancelVerification.png"),
				desc: "礼品卡核销",
			},
			{
				path: "/resetCard",
				imgUrl: require("../image/icon_giftcard_return.png"),
				desc: "礼品卡退款",
			},
			{
				path: "/writeoffLog",
				imgUrl: require("../image/icon_5.png"),
				desc: "礼品卡核销记录",
			},
		];
		this.classIcon.list = [
			{
				imgUrl: require("../image/icon_7.png"),
				path: "/reportSales",
				desc: "上报销售",
				text: "上报销售(商户端)",
			},
			{
				imgUrl: require("../image/icon_8.png"),
				path: "/estate",
				desc: "物业报修",
				text: "物业报修(商户端)",
			},
			{
				imgUrl: require("../image/icon_notice.png"),
				path: "/notice",
				desc: "商场公告",
				text: "商场公告(商户端)",
			},
			{
				imgUrl: require("../image/icon_7.png"),
				path: "/reviewSales",
				desc: "上报销售",
				msg: "上报销售(商管端)",
			},
			{
				imgUrl: require("../image/icon_8.png"),
				path: "/estateManage",
				desc: "物业报修",
				msg: "物业报修(商管端)",
			},
			{
				imgUrl: require("../image/icon_8.png"),
				path: "/estateWorker",
				desc: "物业报修",
				text: "物业报修(维修工端)",
			},
		];
		this.topIcon.list = this.filterPath(
			this.topIcon.list,
			(this as any).$global.routes
		).filter((item:any) => item.path != (this as any).$global.addVerificationByManual);
		let businessEntityId = this.$global.parentBusinessEntityId
		if (businessEntityId==290||businessEntityId==100081014||businessEntityId==100081013) {
			this.topIcon.list.push({
				path: "ERP",
				type: 'miniProgram',
				imgUrl: require("../image/icon_y_erp.png"),
				desc: "优品道ERP",
			  })
		}
		this.classIcon.list = this.filterPath(
			this.classIcon.list,
			(this as any).$global.routes
		);
	}
	getActivityList() {
		this.listLoading = true;
		this.$store
			.dispatch("activityManagement/getActivityList", {
				pageNum: 1,
				pageSize: 5,
				isUsable: 1,
			})
			.then((res) => {
				this.listLoading = false;
				if (res.success) {
					this.activeList = res.success.data.list;
					this.activeList.map((item: any) => {
						let _item = item;
						_item.activityStartDate = (this as any).$format(
							_item.activityStartDate,
							"YYYY.MM.DD"
						);
						_item.activityEndDate = (this as any).$format(
							_item.activityEndDate,
							"YYYY.MM.DD"
						);
						return _item;
					});
				}
			});
	}
	filterPath(arr1: any, arr2: any) {
		return arr1.filter((item: any) => arr2.indexOf(item.path) >= 0);
	}
	async getcurrentDaySaleRecord(){
		const { error, success, }: any  = await (this as any).$request('CURRENTDAY_SALERECORD',{
			shopId:localStorage.getItem('ma6_businessEntityId')
		})
		if(success){
			if(success.data && success.data.length == 0){
				this.listLoading = false;
				(this as any).$global.homeReportSalesFlag = false;
				let time:any = (this as any).$format(new Date(), "YYYY.MM.DD");
				localStorage.setItem('homeReportSalesTime',time);
				Dialog.alert({
					title: '',
					width:"82%",
					message: '本店铺昨日有销售数据未上报，请及时上报！',
					confirmButtonText:"好的",
					confirmButtonColor:"#0245BF",
					className:"homeReportSales"
				})
					.then(() => {
						(this as any).$router.push('/reportSales/form')
					})
			}
		}
	}
	async getNotice() {
		const { error, success, }: any  = await (this as any).$request('NOTICE_SHOW',{
			businessId:Number(localStorage.getItem('ma6_parentBusinessEntityId'))
		})
		if(success) {
			(this as any).noticeShow = !!success.data
			this.noticeContent = (success.data || {}).noticeContent
		}
	}
}
